import AppStoreBadge from '@/images/app-badges/app-store-badge.svg';
import GooglePlayBadge from '@/images/app-badges/google-play-badge.svg';

const IOS_APP_STORE_URL =
  'https://apps.apple.com/de/app/vytal-partner/id1509980663';
const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.vytalmerchantapp&hl=en';

export default function PartnerAppRedirect() {
  return (
    <div className="tw:min-h-screen tw:flex tw:items-center tw:justify-center tw:bg-background tw:p-4">
      <div className="tw:text-center tw:max-w-md">
        <h1 className="tw:text-3xl tw:font-bold tw:text-foreground tw:mb-4">
          Vytal Partner App
        </h1>
        <p className="tw:text-lg tw:text-muted-foreground tw:mb-8">
          Please select your platform:
        </p>
        <div className="tw:flex tw:flex-col tw:gap-4 tw:items-center">
          <a
            href={IOS_APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="tw:transition-transform tw:hover:scale-105"
          >
            <img
              src={AppStoreBadge}
              alt="Download on the App Store"
              className="tw:h-14 tw:w-auto"
            />
          </a>
          <a
            href={ANDROID_PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="tw:transition-transform tw:hover:scale-105"
          >
            <img
              src={GooglePlayBadge}
              alt="Get it on Google Play"
              className="tw:h-14 tw:w-auto"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
